import { loadStripe } from '@stripe/stripe-js/dist/pure.esm.js';

export default {

    namespaced: true,

    state() {
        return {
            stripe: null,
            card: null,
        };
    },

    getters: {
        stripe: (state) => state.stripe,
        card: (state) => state.card,
    },

    mutations: {
        gotStripe(state, stripe) {
            state.stripe = stripe;
        },
        gotCard(state, card) {
            state.card = card;
        }
    },

    actions: {
        async loadStripe({ commit }, { publishableKey, stripeAccount }) {
            const stripe = await loadStripe(publishableKey, {
                stripeAccount
            });
            commit('gotStripe', stripe);
        },
        async loadStripeCard({ commit }, { publishableKey, clientSecret, stripeAccount }) {
            const stripe = await loadStripe(publishableKey, {
                stripeAccount
            });
            const elements = stripe.elements({
                clientSecret
            });
            const card = elements.create('card', {
                hidePostalCode: true,
                style: {
                    base: {
                        lineHeight: '1.429'
                    }
                }
            });

            commit('gotStripe', stripe);
            commit('gotCard', card);
        }
    }

};